class VariantRadios extends HTMLElement {
  constructor() {
    super();

    this.productForm = document.getElementById(`product-form-${this.dataset.section}`);
    this.submitButton = this.productForm.querySelector('[name="add"]');
    this.klaviyoButton = this.productForm.querySelector('product-stock-notification');

    this.allOption1s = this.querySelectorAll('[data-variant-option="1"] input[type="radio"]');
    this.allOption2s = this.querySelectorAll('[data-variant-option="2"] input[type="radio"]');

    // get initial options
    if (this.allOption1s) {
      this.selectedOption1 = Array.from(this.allOption1s).find((radio) => radio.checked).value;
    }

    if (this.allOption2s.length) {
      this.selectedOption2 = Array.from(this.allOption2s).find((radio) => radio.checked).value;
    }

    this.updateOptions();
    this.highlightOptions('init');

    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    if (event) {
      this.selectedVariantOption = event.target.value;
      this.selectedVariantOptionIndex = parseInt(event.target.closest('[data-variant-option]').dataset.variantOption);
    }

    this.updateOptions();
    this.updateMasterId();
    this.highlightOptions('change');

    if (!this.currentVariant) {
      this.toggleForm(true, '');
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateURL();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.variantOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.variantOptions[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        detail: {
          variant: this.currentVariant,
        },
      }),
    );
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions(type) {
    // create an object of the available variant options2. We don't need 1 or 3 because the first options are always available in some configuration or other and the last one is based on what is left after a customer selects 1 and 2.
    const variantOptions2Array = [];
    this.allOption2s.forEach((input) => {
      variantOptions2Array.push(input.value);
    });

    // on load, set initial option
    if (!this.selectedVariantOptionIndex) this.selectedVariantOptionIndex = 1;

    // we don't check for clicks on the 3rd option
    if (this.selectedVariantOptionIndex !== 3) {
      // disable the input options. We re-enable them based on availability
      if (this.selectedVariantOptionIndex === 1) {
        this.allOption2s.forEach((optionValue) => {
          optionValue.classList.add('disabled');
          optionValue.setAttribute('disabled', true);
          optionValue.checked = false;
        });
      }

      // always disable option3s and only enable the available ones
      this.querySelectorAll('[data-variant-option="3"] input[type="radio"]').forEach((optionValue) => {
        optionValue.classList.add('disabled');
        optionValue.setAttribute('disabled', true);
        optionValue.checked = false;
      });

      // set the selected option1

      if (type === 'change') {
        if (this.selectedVariantOptionIndex === 1) this.selectedOption1 = this.selectedVariantOption;
        if (this.selectedVariantOptionIndex === 2) this.selectedOption2 = this.selectedVariantOption;
      }

      // Filter the variants based on the first selected option
      const initialOptionsArray = this.getVariantData().filter((variant) => variant.option1 === this.selectedOption1);
      let leftOverOptionsArray = initialOptionsArray.filter((variant) => variant.option2 === this.selectedOption2);

      // in case the latest option2 is not available for option2, reset it
      if (leftOverOptionsArray.length === 0) {
        this.selectedOption2 = initialOptionsArray[0].option2;
        leftOverOptionsArray = initialOptionsArray.filter((variant) => variant.option2 === this.selectedOption2);
      }

      initialOptionsArray.forEach((variant) => {
        // first option is clicked
        if (this.selectedVariantOptionIndex === 1) {
          // only one variant option with multiple options
          if (variantOptions2Array.length === 0) {
            this.currentVariant = leftOverOptionsArray[0];
            return;
          }

          // loop through all options2 and enable the ones that are available for option1
          variantOptions2Array.forEach((option) => {
            if (variant.option2 === option) {
              this.enableOptions(2, option);
            }
          });

          if (leftOverOptionsArray.length === 0) return;

          // load the 3rd options based on the selected first and second option
          leftOverOptionsArray.forEach((leftOverVariant, index) => {
            this.enableOptions(3, leftOverVariant.option3, index, leftOverVariant);
          });
        }

        // second option is clicked
        if (leftOverOptionsArray.length === 0) return;
        if (this.selectedVariantOptionIndex === 2 && variant.option2 === this.selectedOption2) {
          leftOverOptionsArray.forEach((leftOverVariant, index) => {
            this.enableOptions(3, leftOverVariant.option3, index, leftOverVariant);
          });
        }
      });
    }
  }

  enableOptions(optionNumber, value, index, variant) {
    const input = this.querySelector(`[data-variant-option="${optionNumber}"] input[value="${value}"]`);

    if (!input) return;

    input.removeAttribute('disabled');
    input.classList.remove('disabled');

    if (optionNumber === 2) {
      if (input.value === this.selectedOption2) {
        input.checked = true;
      }
    }
    if (optionNumber === 3 && index === 0) {
      input.checked = true;
      this.currentVariant = variant;
    }
  }

  updateURL() {
    if (!this.currentVariant || !document.body.classList.contains('template-product')) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const input = this.productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  renderProductInfo() {
    // show loader
    this.submitButton.classList.add('loading');

    // disable the button
    this.toggleForm();

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // update the form
        if (this.currentVariant) {
          this.toggleForm(!this.currentVariant.available, window.variantStrings.soldOut);
        }

        // update the sku, price, description and inventory content
        const skuId = `sku-${this.dataset.section}`;
        const priceId = `price-${this.dataset.section}`;
        const inventoryId = `inventory-${this.dataset.section}`;
        const descriptionId = `description-${this.dataset.section}`;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const skuDestination = document.getElementById(skuId);
        const skuSource = html.getElementById(skuId);

        const priceDestination = document.getElementById(priceId);
        const priceSource = html.getElementById(priceId);

        const inventoryDestination = document.getElementById(inventoryId);
        const inventorySource = html.getElementById(inventoryId);

        const descriptionDestination = document.getElementById(descriptionId);
        const descriptionSource = html.getElementById(descriptionId);

        // Metafields have the metafield namespace and key as value of the data attribute.
        const metafields = document.querySelectorAll('[data-product-info-variant-metafield]');
        if (metafields) {
          metafields.forEach((element) => {
            const metafieldName = element.dataset.productInfoVariantMetafield;
            const metafieldSource = html.querySelector(`[data-product-info-variant-metafield=${metafieldName}]`);
            if (metafieldSource) element.innerHTML = metafieldSource.innerHTML;
          });
        }

        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        }

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
        }

        if (inventorySource && inventoryDestination) {
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        }

        if (descriptionSource && descriptionDestination) {
          descriptionDestination.innerHTML = descriptionSource.innerHTML;
        }

        // Update the inventory quantity inputs
        const inventoryQtyDestination = this.productForm.querySelector('input[name="inventory_quantity"]');
        const inventoryQtySource = html
          .querySelector(`#product-form-${this.dataset.section}`)
          .querySelector('input[name="inventory_quantity"]');
        inventoryQtyDestination.value = inventoryQtySource.value;

        // update the set creator object
        const setConfig = this.productForm.querySelector('[data-set-configurator-object]');
        const newSetConfigObject = {
          productTitle: this.currentVariant.name,
          productHandle: setConfig.dataset.setConfiguratorObject,
          variantId: this.currentVariant.id,
          variantPrice: this.currentVariant.price,
        };
        setConfig.textContent = JSON.stringify(newSetConfigObject);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
      })
      .catch((error) => {
        debug() && console.log(error);
        this.setUnavailable();
      });
  }

  /**
   * toggleForm
   * @param {Boolean} disable
   * @param {String} text
   * @returns {void}
   */
  toggleForm(disable = true, text) {
    const addButtonText = this.submitButton?.querySelector('[data-add-to-cart-button-text]');

    if (!this.submitButton || !addButtonText) return;

    if (this.submitButton.querySelector('.icon').classList.contains('hidden'))
      this.submitButton.querySelector('.icon').classList.remove('hidden');

    // always hide the klaviyo button
    if (this.klaviyoButton) {
      this.klaviyoButton.classList.add('hidden');
    }

    if (disable) {
      this.submitButton.setAttribute('disabled', true);

      // when sold out
      if (text) {
        addButtonText.textContent = text;
        if (this.klaviyoButton) {
          // update the klaviyo input
          this.klaviyoButton.classList.remove('hidden');
          this.submitButton.classList.add('hidden');
        }
      } else {
        this.submitButton.classList.remove('hidden');
      }
    } else {
      this.submitButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const addButtonText = this.submitButton.querySelector('[data-add-to-cart-button-text]');
    this.submitButton.querySelector('.icon').classList.add('hidden');

    if (!this.submitButton || !addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    const priceWrapper = document.getElementById(`price-${this.dataset.section}`);
    const skuWrapper = document.getElementById(`sku-${this.dataset.section}`);
    const inventoryWrapper = document.getElementById(`inventory-${this.dataset.section}`).querySelector('p');

    priceWrapper.innerHTML = '&nbsp';
    skuWrapper.innerHTML = '&nbsp';
    inventoryWrapper.textContent = window.variantStrings.unavailable;
    inventoryWrapper.classList.add('label-stock--unavailable');
  }

  getVariantData() {
    const { textContent } = this.querySelector('[type="application/json"]');
    this.variantData = this.variantData || JSON.parse(textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
